import client from './client';
import type { ShelfInventory } from '@/types/api';

export interface AdjustInventoryRequest {
  productVariantId: string;
  locationId: string;
  quantity: number;
  notes?: string;
  binLocation?: string | null;
  binNumber?: string | null;
}

export interface VariantInventory {
  variantId: string;
  variantSku: string;
  fullSku: string;
  productId: string;
  productName: string;
  locationId: string;
  locationName: string;
  quantityOnShelf: number;
  quantityReserved: number;
  availableQuantity: number;
}

export const inventoryApi = {
  getAll: async (): Promise<ShelfInventory[]> => {
    const response = await client.get<ShelfInventory[]>('/inventory');
    return response.data;
  },

  getByLocation: async (locationId: string): Promise<ShelfInventory[]> => {
    const response = await client.get<ShelfInventory[]>(`/inventory/location/${locationId}`);
    return response.data;
  },

  getVariantsByLocation: async (locationId: string): Promise<VariantInventory[]> => {
    const response = await client.get<VariantInventory[]>(`/inventory/location/${locationId}/variants`);
    return response.data;
  },

  getLowStock: async (): Promise<ShelfInventory[]> => {
    const response = await client.get<ShelfInventory[]>('/inventory/low-stock');
    return response.data;
  },

  adjust: async (data: AdjustInventoryRequest): Promise<ShelfInventory> => {
    const response = await client.put<ShelfInventory>('/inventory/adjust', data);
    return response.data;
  },

  transfer: async (
    variantId: string,
    fromLocationId: string,
    toLocationId: string,
    quantity: number,
    notes?: string
  ): Promise<void> => {
    await client.post('/inventory/transfer', null, {
      params: { variantId, fromLocationId, toLocationId, quantity, notes }
    });
  },

  addStock: async (inventoryId: string, quantity: number, notes?: string): Promise<ShelfInventory> => {
    const response = await client.post<ShelfInventory>(`/inventory/${inventoryId}/add`, null, {
      params: { quantity, notes }
    });
    return response.data;
  },

  removeStock: async (inventoryId: string, quantity: number, notes?: string): Promise<ShelfInventory> => {
    const response = await client.post<ShelfInventory>(`/inventory/${inventoryId}/remove`, null, {
      params: { quantity, notes }
    });
    return response.data;
  },
};
